const ans = {};
let selectedGoals = [];
let history = [];

const P = {
  svHer:       { name:'Smart Vitamins for Her',      role:'Stap 1 — Dagelijkse basis',              desc:'Energie, immuniteit en vrouwelijke vitaliteit. Duo-capsule met omega-3, B-vitamines, ijzer en folaat.',                       price:30, url:'https://insentials.com/products/smart-vitamins-for-her' },
  svHim:       { name:'Smart Vitamins for Him',      role:'Stap 1 — Dagelijkse basis',              desc:'Energie, immuniteit en mannelijke vitaliteit. Duo-capsule met omega-3, B-vitamines, zink en saw palmetto.',                   price:30, url:'https://insentials.com/products/smart-vitamins-for-him' },
  svJunior:    { name:'Smart Vitamins Junior',       role:'Dagelijkse basis',                        desc:'Kauwtablet voor kinderen (3+). Ondersteunt het immuunsysteem, normale groei en botgezondheid.',                             price:30, url:'https://insentials.com/products/smart-vitamins-junior' },
  detox:       { name:'Detox Boost',                 role:'Stap 2 — Lever & ontgifting',            desc:'LIPOGLUTATHOX™ — ondersteunt de lever en bevordert de natuurlijke ontgifting. Verbetert de opname van alle supplementen.',    price:70, url:'https://insentials.com/products/detox-boost' },
  liverboost:  { name:'Liverboost Forte',            role:'Stap 2 — Intensieve leverondersteuning', desc:'PROANTRODIA™ — stimuleert leverherstel en vetmetabolisme. Meetbare verbetering van bloedwaarden na 12 weken.',               price:85, url:'https://insentials.com/products/liverboost-forte' },
  deepSleep:   { name:'Deep Sleep',                  role:'Stap 3 — Slaap',                         desc:'GABASOMNUS™ — melatonine, valeriaan en GABA. Helpt sneller in slaap vallen en ondersteunt een kwalitatieve nachtrust.',       price:40, url:'https://insentials.com/products/deep-sleep' },
  balanceMe:   { name:'Balance Me',                  role:'Stap 3 — Hormonen & stress',             desc:'ADAPTOHORMONAL C™ — rhodiola, maca, magnesium en B-vitamines. Ondersteunt hormonale balans en helpt stress verminderen.',     price:40, url:'https://insentials.com/products/balance-me' },
  mentalBoost: { name:'Mental Boost',                role:'Stap 3 — Mentale focus',                 desc:"NRM3+ — lion's mane, saffraan en Zynamite®. Ondersteunt mentale helderheid, focus en een positieve stemming.",               price:40, url:'https://insentials.com/products/mental-boost' },
  immuniq:     { name:'Immuniq-10 Boost',            role:'Stap 3 — Energie & weerstand',           desc:'ENERGIN-C™ — magnesium, ginseng, co-enzym Q10 en B-vitamines. Vermindert vermoeidheid en versterkt het immuunsysteem.',      price:45, url:'https://insentials.com/products/immuniq-10-boost' },
  glh2:        { name:'GLH-2',                       role:'Stap 3 — Gewichtsbeheersing',            desc:'GLUCOREDUCTASE™ — berberine, Reducose® en chroom. Stabiele bloedsuikerspiegel en minder cravings naar suiker.',             price:70, url:'https://insentials.com/products/glh-2' },
  fatBurner:   { name:'Fat Burner',                  role:'Stap 3 — Vetverbranding',                desc:'LIPOICINE™ — groene thee, capsäicine en java-thee. Activeert het rustmetabolisme en bevordert vetverbranding.',              price:85, url:'https://insentials.com/products/fat-burner' },
  innerBeauty: { name:'Inner Beauty',                role:'Stap 3 — Huidgezondheid',                desc:'H5-NADH™ — NADH, vitamine C, zink en koper. Huidverjonging op celniveau, hydratatie en een natuurlijke glow.',              price:75, url:'https://insentials.com/products/inner-beauty' },
  glowGoddess: { name:'Glow Goddess',                role:'Stap 3 — Huid & bescherming',            desc:'SS-ASTACAROTENE™ — astaxanthine, bèta-caroteen en luteïne. Beschermt de huid van binnenuit, ondersteunt een stralende teint.', price:40, url:'https://insentials.com/products/glow-goddess' },
  smartCollagen:{ name:'Smart Collagen 10g Shot',   role:'Stap 3 — Collageen & anti-aging',        desc:'COLLAXINE™ — 10g collageen, vitamine C en Keraboost™. Verstevigt de huid, vermindert fijne lijntjes, ondersteunt haar en nagels.', price:85, url:'https://insentials.com/products/smart-collagen-shot' },
  hairStrength:{ name:'Hair Strength+',              role:'Stap 3 — Haar',                          desc:'FOLLICURE™ — biotine, zink, saw palmetto en quercetine. Ondersteunt haargroei en beperkt haaruitval.',                       price:70, url:'https://insentials.com/products/hair-strength' },
  gutNight:    { name:'Gut Night',                   role:'Stap 3 — Spijsvertering',                desc:'GASTROLISSE™ — citroenmelisse, mariadistel en NAC. Ondersteunt spijsvertering en maagcomfort.',                              price:40, url:'https://insentials.com/products/gut-night' },
  ultraMove:   { name:'Ultra Move',                  role:'Stap 3 — Gewrichten',                    desc:'CURCUFLEX™ — curcumine 95%, PEA en piperine. Helpt gewrichten soepel te houden.',                                          price:40, url:'https://insentials.com/products/ultra-move' },
  jMagneflex:  { name:'J-Magneflex II Shot',         role:'Stap 3 — Spieren & gewrichten',         desc:'Dagelijkse shot met magnesiumionen, collageen type II en glucosamine. Ondersteunt spieren en de elektrolytenbalans.',         price:75, url:'https://insentials.com/products/j-magneflex-ii' },
  menoComfort: { name:'Meno Comfort',                role:'Stap 3 — Menopauze',                     desc:'OESTRAEDIM™ — curcuma longa, broccoli-extract en piperine. Ondersteunt vrouwelijk comfort tijdens hormonale veranderingen.',  price:45, url:'https://insentials.com/products/meno-comfort' },
};

const GOALS = [
  { id:'slaap',         label:'Beter slapen',                  sub:'Moeilijk inslapen, onrustig slapen of nooit echt uitgerust',      gender:['vrouw','man'] },
  { id:'stress',        label:'Stress verminderen',            sub:'Overprikkeld, uitgeput of moeilijk tot rust kunnen komen',        gender:['vrouw','man'] },
  { id:'energie',       label:'Meer energie',                  sub:'Moeheid overdag, energie-dips of weinig vitaliteit',              gender:['vrouw','man'] },
  { id:'focus',         label:'Mentale focus & helderheid',    sub:'Hersenmist, concentratieproblemen of een onrustige stemming',     gender:['vrouw','man'] },
  { id:'lever',         label:'Lever & ontgifting',            sub:'Drukke levensstijl, alcoholgebruik of verhoogde bloedwaarden',    gender:['vrouw','man'] },
  { id:'afvallen',      label:'Afvallen of gewicht beheersen', sub:'Cravings, moeite met afvallen of een trage stofwisseling',        gender:['vrouw','man'] },
  { id:'huid',          label:'Betere huid',                   sub:'Doffe huid, fijne lijntjes, glow of anti-aging',                  gender:['vrouw','man'] },
  { id:'haar',          label:'Sterker haar',                  sub:'Haaruitval, dunner wordend haar of trage haargroei',              gender:['vrouw','man'] },
  { id:'spijsvertering',label:'Betere spijsvertering',         sub:'Opgeblazen gevoel, gasvorming of een onrustige buik',             gender:['vrouw','man'] },
  { id:'gewrichten',    label:'Gewrichten & spieren',          sub:'Stijfheid, gewrichtspijn of spierpijn na sport',                  gender:['vrouw','man'] },
  { id:'hormonen',      label:'Hormonale balans',              sub:'PMS, onregelmatige cyclus of hormonale wisselingen',              gender:['vrouw'], ageMax:54 },
  { id:'menopauze',     label:'Menopauze-klachten verlichten', sub:'Opvliegers, nachtelijk zweten of gewichtstoename',               gender:['vrouw'], ageMin:44 },
];

function goalProduct(goalId, intensity) {
  const leverIntensief = intensity === 'duidelijk' || intensity === 'ernstig';
  const map = {
    slaap:         { primary: P.deepSleep },
    stress:        { primary: P.balanceMe },
    energie:       { primary: P.immuniq },
    focus:         { primary: P.mentalBoost },
    lever:         { primary: leverIntensief ? P.liverboost : P.detox,
                     note: leverIntensief ? 'Combineer altijd met Detox Boost voor dagelijkse leverondersteuning.' : null },
    afvallen:      { primary: P.glh2, secondary: P.fatBurner,
                     note: 'Voeg Fat Burner toe als je ook het vetmetabolisme verder wilt ondersteunen.' },
    huid:          { primary: P.innerBeauty, secondary: P.glowGoddess },
    haar:          { primary: P.hairStrength },
    spijsvertering:{ primary: P.gutNight },
    gewrichten:    { primary: P.ultraMove, secondary: P.jMagneflex,
                     note: 'J-Magneflex II Shot is een aanvulling voor intensievere gewrichtsondersteuning.' },
    hormonen:      { primary: P.balanceMe },
    menopauze:     { primary: P.menoComfort, secondary: P.balanceMe,
                     note: 'Meno Comfort en Balance Me vullen elkaar aan tijdens de menopauze.' },
  };
  return map[goalId] || null;
}

function goalLabel(id) {
  const g = GOALS.find(x => x.id === id);
  return g ? g.label : id;
}

function show(id) {
  document.querySelectorAll('.screen').forEach(s => s.classList.remove('active'));
  document.getElementById('screen-' + id).classList.add('active');
  updateProgress(id);
  window.scrollTo(0,0);
}

function nav(from, to) { history.push(from); show(to); }
function goBack() { if (history.length > 0) show(history.pop()); else show('start'); }
function restartQuiz() { Object.keys(ans).forEach(k => delete ans[k]); selectedGoals = []; history = []; show('start'); }

function updateProgress(id) {
  const map = { start:0, q1:1, q2:2, q3:3, q4:4, q5:5, q6:6, result:6 };
  const step = map[id] || 0;
  const wrap = document.getElementById('progressWrap');
  if (id === 'start' || id === 'result') { wrap.style.display='none'; return; }
  wrap.style.display = 'block';
  document.getElementById('progressFill').style.width = (step/6*100)+'%';
  document.getElementById('progressLabel').textContent = 'Vraag '+step+' van 6';
}

function startQuiz() { history=[]; nav('start','q1'); }

function pickGender(val, btn) {
  ans.gender = val;
  btn.closest('.options-grid').querySelectorAll('.option-btn').forEach(b => b.classList.remove('selected'));
  btn.classList.add('selected');
  if (val === 'kind') { setTimeout(()=>{ buildKindResult(); nav('q1','result'); },250); return; }
  setTimeout(()=>{ buildAgeOptions(val); nav('q1','q2'); },250);
}

function buildAgeOptions(gender) {
  const opts = gender==='vrouw'
    ? [{v:'onder35',label:'Jonger dan 35 jaar'},{v:'35tot44',label:'35 tot 44 jaar'},{v:'45tot54',label:'45 tot 54 jaar'},{v:'55plus',label:'55 jaar of ouder'}]
    : [{v:'onder40',label:'Jonger dan 40 jaar'},{v:'40tot54',label:'40 tot 54 jaar'},{v:'55plus',label:'55 jaar of ouder'}];
  const c = document.getElementById('ageOptions');
  c.innerHTML='';
  opts.forEach(o => {
    const b = document.createElement('button');
    b.className='option-btn';
    b.innerHTML=`<span class="opt-ind"></span><span class="opt-content"><span class="opt-title">${o.label}</span></span>`;
    b.onclick=()=>{ ans.age=o.v; b.classList.add('selected'); setTimeout(()=>afterAge(),250); };
    c.appendChild(b);
  });
}

function ageNum() {
  const a=ans.age;
  if(!a) return 30;
  if(a==='onder35'||a==='onder40') return 30;
  if(a==='35tot44'||a==='40tot54') return 42;
  if(a==='45tot54') return 49;
  if(a==='55plus') return 57;
  return 30;
}

function afterAge() {
  if(ans.gender==='vrouw' && ans.age!=='55plus') { nav('q2','q3'); }
  else { buildGoalsOptions(); nav('q2','q4'); }
}

function pickPregnancy(val, btn) {
  ans.pregnancy=val;
  btn.closest('.options-grid').querySelectorAll('.option-btn').forEach(b=>b.classList.remove('selected'));
  btn.classList.add('selected');
  if(val==='zwanger'||val==='bezig') { setTimeout(()=>{ buildPregnancyResult(val); nav('q3','result'); },250); return; }
  setTimeout(()=>{ buildGoalsOptions(); nav('q3','q4'); },250);
}

function buildGoalsOptions() {
  const gender=ans.gender, age=ageNum();
  const c=document.getElementById('goalsOptions');
  c.innerHTML=''; selectedGoals=[];
  const filtered=GOALS.filter(g=>{
    if(!g.gender.includes(gender)) return false;
    if(g.ageMin && age<g.ageMin) return false;
    if(g.ageMax && age>g.ageMax) return false;
    return true;
  });
  const stepNum=(ans.gender==='man'||ans.age==='55plus')?3:4;
  document.getElementById('q4Step').textContent=`Stap ${stepNum} van 6`;
  filtered.forEach(g=>{
    const b=document.createElement('button');
    b.className='option-btn'; b.dataset.id=g.id;
    b.innerHTML=`<span class="opt-ind check"></span><span class="opt-content"><span class="opt-title">${g.label}</span><span class="opt-sub">${g.sub}</span></span>`;
    b.onclick=()=>toggleGoal(g.id,b);
    c.appendChild(b);
  });
  document.getElementById('btnGoalsNext').disabled=true;
}

function toggleGoal(id,btn) {
  const i=selectedGoals.indexOf(id);
  if(i>-1){selectedGoals.splice(i,1);btn.classList.remove('selected');}
  else{selectedGoals.push(id);btn.classList.add('selected');}
  document.getElementById('btnGoalsNext').disabled=selectedGoals.length===0;
}

function goToQ5() {
  ans.goals=[...selectedGoals];
  if(selectedGoals.length===1){ans.priority=selectedGoals[0];nav('q4','q6');return;}
  buildPriorityOptions(); nav('q4','q5');
}

function buildPriorityOptions() {
  const c=document.getElementById('priorityOptions'); c.innerHTML='';
  const stepNum=(ans.gender==='man'||ans.age==='55plus')?4:5;
  document.getElementById('q5Step').textContent=`Stap ${stepNum} van 6`;
  selectedGoals.forEach(id=>{
    const g=GOALS.find(x=>x.id===id); if(!g)return;
    const b=document.createElement('button');
    b.className='option-btn';
    b.innerHTML=`<span class="opt-ind"></span><span class="opt-content"><span class="opt-title">${g.label}</span></span>`;
    b.onclick=()=>{ans.priority=id;b.classList.add('selected');setTimeout(()=>nav('q5','q6'),250);};
    c.appendChild(b);
  });
}

function pickIntensity(val,btn) {
  ans.intensity=val;
  btn.closest('.options-grid').querySelectorAll('.option-btn').forEach(b=>b.classList.remove('selected'));
  btn.classList.add('selected');
  setTimeout(()=>{ nav('q6','lead'); },280);
}

function phaseCard(num, title, duration, products, note) {
  const total=products.reduce((s,p)=>s+p.price,0);
  const items=products.map(p=>`
    <div class="product-item">
      <div>
        <div class="product-role">${p.role}</div>
        <div class="product-name">${p.name}</div>
        <div class="product-desc">${p.desc}</div>
        <a href="${p.url}" target="_blank" class="product-link">Bekijk product &#8599;</a>
      </div>
      <div class="product-right"><div class="product-price">&euro;${p.price}/mnd</div></div>
    </div>`).join('');
  return `<div class="phase-card">
    <div class="phase-label">Fase ${num}</div>
    <div class="phase-title">${title}</div>
    <div class="phase-duration">${duration}</div>
    ${items}
    <div class="phase-total">Totaal: <strong>&plusmn;&euro;${total}/maand</strong></div>
    ${note?`<div class="phase-note">${note}</div>`:''}
  </div>`;
}

function buildFullResult() {
  const gender=ans.gender, intensity=ans.intensity, goals=ans.goals||[], priority=ans.priority;
  const base=gender==='man'?P.svHim:P.svHer;
  const leverUrgent=goals.includes('lever')&&(intensity==='duidelijk'||intensity==='ernstig');
  const needsConsult=intensity==='ernstig'||goals.length>=4||(goals.includes('menopauze')&&goals.includes('lever')&&goals.includes('afvallen'));

  const p1label=goalLabel(priority).toLowerCase();
  document.getElementById('resultTitle').textContent=`Je plan — ${p1label} als eerste prioriteit`;

  const intensityTxt={preventief:'Je wilt preventief goed voor jezelf zorgen.',mild:'Je ervaart milde klachten en wilt die aanpakken.',duidelijk:'Je hebt duidelijke, terugkerende klachten.',ernstig:'Je ervaart ernstige of langdurige klachten.'};
  const goalLabels=goals.map(id=>goalLabel(id).toLowerCase());
  const goalsStr=goalLabels.length===1?goalLabels[0]:goalLabels.slice(0,-1).join(', ')+' en '+goalLabels[goalLabels.length-1];
  document.getElementById('resultIntro').textContent=`${intensityTxt[intensity]||''} Op basis van jouw profiel hebben we een gefaseerd plan samengesteld gericht op ${goalsStr}. Start rustig, evalueer na elke fase en bouw van daaruit verder.`;

  let phase1Products, phase1Note;
  if(leverUrgent){
    phase1Products=[base,P.liverboost,P.detox];
    phase1Note="Je lever heeft urgente aandacht nodig. Start de drie producten tegelijk: Smart Vitamins 's morgens, Liverboost Forte en Detox Boost 's avonds. Bespreek dit ook met je arts als je medicatie gebruikt.";
  } else {
    phase1Products=[base,P.detox];
    phase1Note="Smart Vitamins 's morgens, Detox Boost 's avonds. De lever-eerst aanpak verbetert de opname van alle supplementen. Geef je lichaam 4-6 weken om op te starten.";
  }
  let phasesHTML=phaseCard(1,'De basis opbouwen','Maand 1-2',phase1Products,phase1Note);

  const effectivePriority=(priority==='lever'&&leverUrgent)?(goals.filter(g=>g!=='lever')[0]||null):priority;
  if(effectivePriority) {
    const gp=goalProduct(effectivePriority,intensity);
    if(gp){
      const phase2Products=leverUrgent?[base,P.liverboost,P.detox]:[base,P.detox,gp.primary];
      const phase2Title=leverUrgent?'Lever blijven ondersteunen':goalLabel(effectivePriority);
      const phase2Note=leverUrgent?'Evalueer na maand 4 hoe je leverwaarden staan. Voeg daarna het volgende supplement toe zodra de basis stabiel is.':(gp.note||null);
      phasesHTML+=phaseCard(2,phase2Title,'Maand 3-4',phase2Products,phase2Note);
    }
  } else if(priority==='lever'&&leverUrgent) {
    phasesHTML+=phaseCard(2,'Evaluatie & consolidatie','Maand 3-4',[base,P.liverboost,P.detox],'Bloedwaarden laten checken na 3 maanden. Als de leverfunctie verbeterd is, kun je Liverboost Forte afbouwen naar een onderhoudsdosis.');
  }

  const secondaryGoals=goals.filter(g=>g!==priority&&g!=='lever');
  if(secondaryGoals.length>0){
    const sec=secondaryGoals[0];
    const gp2=goalProduct(sec,intensity);
    if(gp2){
      phasesHTML+=phaseCard(3,goalLabel(sec),'Maand 5+',[base,P.detox,gp2.primary],gp2.note||`Voeg ${gp2.primary.name} toe als Stap 3 zodra je tevreden bent over de resultaten van fase 2.`);
    }
  }

  document.getElementById('resultPhases').innerHTML=phasesHTML;
  document.getElementById('resultEval').innerHTML=`<div class="eval-card"><strong>Evalueer na elke fase</strong><br>Supplementen werken ondersteunend en hun effect is persoonlijk. Geef elk product minstens 6-8 weken voor je beoordeelt. Let op energie, slaap en stemming als eerste signalen. Pas je plan aan op basis van wat je voelt.</div>`;

  if(needsConsult){
    document.getElementById('resultAdvice').innerHTML=`<div class="advice-card"><div class="advice-icon">&#128172;</div><h3>Jouw situatie vraagt om persoonlijk advies</h3><p>Je hebt meerdere doelen of ernstige klachten aangegeven. In dat geval is een persoonlijk gesprek zinvoller dan een standaardplan. Neem contact op met Insentials of je zorgverlener voor advies dat volledig op jou is afgestemd.</p></div>`;
  } else {
    document.getElementById('resultAdvice').innerHTML='';
  }

  document.getElementById('resultCta').innerHTML=`<div class="cta-block"><h3>Klaar om te starten?</h3><p>Bestel je producten direct via Insentials.</p><div class="btn-group"><a href="https://insentials.com/collections/all" target="_blank" class="btn-primary">Bestel via Insentials &#8599;</a></div></div>`;
}

function buildKindResult() {
  document.getElementById('resultTitle').textContent='Smart Vitamins Junior — de dagelijkse basis';
  document.getElementById('resultIntro').textContent='Voor kinderen van 3 tot 12 jaar is Smart Vitamins Junior de aangewezen keuze. Speciaal ontwikkeld voor de behoeften van groeiende kinderen.';
  document.getElementById('resultPhases').innerHTML=phaseCard(1,'Dagelijkse basis','Elke dag',[P.svJunior],"1 kauwtablet per dag, 's morgens innemen. Veilig en speciaal ontwikkeld voor kinderen van 3 tot 12 jaar.");
  document.getElementById('resultEval').innerHTML='';
  document.getElementById('resultAdvice').innerHTML=`<div class="advice-card"><div class="advice-icon">&#128172;</div><h3>Wil je meer specifieke ondersteuning voor jouw kind?</h3><p>Voor aanvullende gezondheidsondersteuning bij kinderen raden we aan een arts of di&#235;tiste te raadplegen.</p></div>`;
  document.getElementById('resultCta').innerHTML=`<div class="cta-block"><h3>Bestel Smart Vitamins Junior</h3><p>Direct beschikbaar via Insentials.</p><div class="btn-group"><a href="https://insentials.com/products/smart-vitamins-junior" target="_blank" class="btn-primary">Bestel via Insentials &#8599;</a></div></div>`;
}

function buildPregnancyResult(type) {
  if(type==='zwanger'){
    document.getElementById('resultTitle').textContent='Veilig supplementenadvies tijdens zwangerschap';
    document.getElementById('resultIntro').textContent='Tijdens de zwangerschap en borstvoeding zijn maar een paar supplementen aanbevolen zonder medisch overleg. Hier zijn de veilige opties.';
    document.getElementById('resultPhases').innerHTML=phaseCard(1,'Veilige dagelijkse basis','Tijdens zwangerschap & borstvoeding',[P.svHer,P.innerBeauty],"Smart Vitamins for Her (met folaat) en Inner Beauty zijn beide veilig bevonden tijdens de zwangerschap en borstvoeding. Smart Vitamins 's morgens, Inner Beauty 's morgens.");
    document.getElementById('resultAdvice').innerHTML=`<div class="advice-card"><div class="advice-icon">&#9888;&#65039;</div><h3>Overleg altijd met je arts of apotheker</h3><p>Detox Boost en de meeste andere supplementen zijn niet aanbevolen tijdens de zwangerschap zonder medisch advies. Raadpleeg je arts of vroedvrouw voor een volledig plan.</p></div>`;
  } else {
    document.getElementById('resultTitle').textContent='Supplementen bij een actieve zwangerschapswens';
    document.getElementById('resultIntro').textContent='Als je probeert zwanger te worden, zijn er supplementen die je lichaam kunnen voorbereiden. Raadpleeg ook je huisarts of gynaecoloog.';
    document.getElementById('resultPhases').innerHTML=phaseCard(1,'Voorbereiding & hormonale balans','Tijdens de zwangerschapswens',[P.svHer,P.balanceMe],'Smart Vitamins for Her bevat folaat en zink, beide essentieel bij een zwangerschapswens. Balance Me ondersteunt hormonale balans via Maca.');
    document.getElementById('resultAdvice').innerHTML=`<div class="advice-card"><div class="advice-icon">&#128172;</div><h3>Overleg met je arts</h3><p>Bij een actieve zwangerschapswens adviseren we altijd een gesprek met je huisarts of gynaecoloog. Zij kunnen jouw situatie volledig beoordelen en aanvullend advies geven.</p></div>`;
  }
  document.getElementById('resultEval').innerHTML='';
  document.getElementById('resultCta').innerHTML=`<div class="cta-block"><h3>Heb je vragen?</h3><p>Bekijk alle producten via Insentials.</p><div class="btn-group"><a href="https://insentials.com/collections/all" target="_blank" class="btn-primary">Bekijk alle producten &#8599;</a></div></div>`;
}

function checkLead() {
  const name = document.getElementById('leadName').value.trim();
  const email = document.getElementById('leadEmail').value.trim();
  const valid = name.length > 0 && /^[^@]+@[^@]+\.[^@]+$/.test(email);
  document.getElementById('btnLeadSubmit').disabled = !valid;
}

function submitLead() {
  const name  = document.getElementById('leadName').value.trim();
  const email = document.getElementById('leadEmail').value.trim();
  if (!name || !email) return;
  ans.leadName  = name;
  ans.leadEmail = email;

  const goals   = (ans.goals||[]).map(id => goalLabel(id)).join(', ');
  const priority = ans.priority ? goalLabel(ans.priority) : '-';
  const intensityMap = {preventief:'Preventief',mild:'Milde klachten',duidelijk:'Duidelijke klachten',ernstig:'Ernstige klachten'};
  const intensityLabel = intensityMap[ans.intensity] || ans.intensity || '-';
  const genderLabel = {vrouw:'Vrouw',man:'Man',kind:'Kind'}[ans.gender] || '-';
  const ageMap = {onder35:'<35',onder40:'<40','35tot44':'35-44','40tot54':'40-54','45tot54':'45-54','55plus':'55+'};
  const ageLabel = ageMap[ans.age] || '-';

  const body = {
    naam:       name,
    email:      email,
    geslacht:   genderLabel,
    leeftijd:   ageLabel,
    doelen:     goals,
    prioriteit: priority,
    intensiteit: intensityLabel,
    zwangerschap: ans.pregnancy || 'n.v.t.',
    datum:      new Date().toLocaleDateString('nl-NL')
  };

  fetch('https://formspree.io/f/mnjygwjj', {
    method: 'POST',
    headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  }).catch(() => {});

  buildFullResult();
  nav('lead','result');
}

updateProgress('start');